import { ScholarshipReportListItemData } from './report-base';

export class ScholarshipReportUserListData extends ScholarshipReportListItemData {
  clubUserProgramFeeID: number;
  userID: number;
  avatar: string;
  firstName: string;
  middleName: string;
  lastName: string;
  gender: string;
  dateAdded: Date;
  feeName: string;
  scholarshipBy: string;
  scholarshipType: string;
  amount: number;
}

export class UserScholarshipReport {
  totalScholarshipMembers: number;
  totalScholarshipAmount: number;
  list: ScholarshipReportUserListData[];

  constructor(data: any = {}) {
    this.totalScholarshipMembers = +data.totalScholarshipMembers;
    this.totalScholarshipAmount = +data.totalScholarshipAmount;
    this.list = data.scholarshipReportList ? data.scholarshipReportList.map(l => new ScholarshipReportUserListData(l)) : [];
  }
}

export class UserScholarship {

  private static stringKeys = ['firstname', 'avatar', 'group', 'fee', 'gender', 'by', 'type', 'credit'];

  firstname: string;
  avatar: string;
  date: Date;
  group: string;
  fee: string;
  gender: string;
  by: string;
  type: string;
  credit: number;

  constructor(data: any = {}) {
    UserScholarship.stringKeys.forEach(key => this[key] = data[key]);
    this.date = data.date ? new Date(data.date) : null;
  }

}

export class ScholarshipReport {

  list: UserScholarship[];
  totalNumber: number;
  totalAmount: number;

  constructor(data: any = {}) {
    this.list = (data.scholarshipReportUserList || []).map(user => new UserScholarship(user));
    this.totalNumber = data.totalNumberOfScholarship || 0;
    this.totalAmount = data.totalScholarshipAmount || 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/models/reports/scholarship-report.ts